import { type KeenSliderInstance } from 'keen-slider';

interface AutoSlideOptions {
  /** 슬라이드 전환 간격 (ms) */
  intervalMs: number;
}

export const createAutoSlidePlugin =
  ({ intervalMs }: AutoSlideOptions) =>
  (slider: KeenSliderInstance) => {
    let timeout: ReturnType<typeof setTimeout>;

    function next() {
      slider.next();
      timeout = setTimeout(next, intervalMs);
    }

    slider.on('created', () => {
      timeout = setTimeout(next, intervalMs);
    });
    slider.on('destroyed', () => {
      clearTimeout(timeout);
    });
  };
